var _rect, _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgStopRail = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 32 32"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 3,
  height: 8,
  x: 14.5,
  y: 22,
  fill: "#333",
  rx: 1.5
})), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 16,
  cy: 13,
  r: 11
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M8 7a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H10a2 2 0 0 1-2-2z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M19.74 19.2v-.84H19v.84h-5.96v-.84h-.76v.84h-.92c-.22 0-.4.18-.4.38 0 .22.18.4.4.4h9.32c.22 0 .38-.18.38-.4 0-.2-.16-.38-.38-.38zm1.48-10.54c-.36-.76-.64-1.36-.94-1.62-.44-.4-2.34-.86-4.28-.86-1.88 0-3.82.46-4.24.86-.3.26-.6.86-.96 1.62-.3.66-.54 1.28-.54 1.64v5.78c0 .46.16.66.78 1.14.46.36.66.52 1.36.52h1.32v.86h4.62v-.86h1.3c.7 0 .9-.16 1.34-.52.62-.5.76-.68.76-1.14V10.3c0-.36-.24-.98-.52-1.64m-2.18-.92v.34c0 .26-.2.48-.46.48h-5.12c-.26 0-.48-.22-.48-.48v-.34zm-5.58 8.92c-.28 0-.48-.2-.48-.48s.2-.5.48-.5.52.22.52.5-.24.48-.52.48m5.12-.06c-.28 0-.5-.2-.5-.48s.22-.5.5-.5.5.22.5.5-.22.48-.5.48m.74-2.5c-.06.34-.4.6-.74.6h-5.12c-.34 0-.68-.26-.74-.6l-.94-3.98c-.06-.34.16-.6.5-.6h7.46c.34 0 .58.26.5.6z"
})));
export { SvgStopRail as ReactComponent };